const actions = {
  SET_STATE: 'document/SET_STATE',
  FETCH_DOCUMENTS: 'document/FETCH_DOCUMENTS',
}

export default actions
